import {
  LOGIN,
  REGISTER,
  ERRORS,
  LOGIN_ERRORS,
  USER
} from "./userTypes";

// action helper function
export const registerAction = (user) => ({ type: REGISTER, payload: user });

export const loginAction = (user) => ({ type: LOGIN, payload: user });

export const registerErrorAction = (error) => ({
  type: ERRORS,
  payload: error,
});
export const loginErrorAction = (error) => ({
  type: LOGIN_ERRORS,
  payload: error,
});
export const userAction = (user) => ({
  type: USER,
  payload: user,
});
export const updateAction = (user) => ({
  type: USER,
  payload: user,
});
